var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 621,
    height: 440,
    viewBox: "0 0 621 440",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2345 431.099C41.996 431.099 45.0452 428.955 45.0452 426.311C45.0452 423.667 41.996 421.523 38.2345 421.523C34.473 421.523 31.4238 423.667 31.4238 426.311C31.4238 428.955 34.473 431.099 38.2345 431.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.285 440C416.047 440 419.096 437.856 419.096 435.212C419.096 432.568 416.047 430.424 412.285 430.424C408.524 430.424 405.474 432.568 405.474 435.212C405.474 437.856 408.524 440 412.285 440Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.081 116.322C585.843 116.322 588.892 114.179 588.892 111.534C588.892 108.89 585.843 106.747 582.081 106.747C578.32 106.747 575.271 108.89 575.271 111.534C575.271 114.179 578.32 116.322 582.081 116.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.532,
    y: 148.577,
    width: 370.207,
    height: 233.992,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.6 359.552L226.71 327.859C220.91 324.487 213.762 324.487 207.963 327.859L166.02 352.067",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.285 423.141C416.871 420.512 416.871 413.903 412.285 411.273L330.219 363.868C325.701 361.305 325.701 354.832 330.219 352.202L504.736 251.255C509.254 248.625 509.254 242.084 504.736 239.454L473.851 221.652",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.005 361.913C284.276 361.913 286.118 360.856 286.118 359.553C286.118 358.249 284.276 357.192 282.005 357.192C279.733 357.192 277.891 358.249 277.891 359.553C277.891 360.856 279.733 361.913 282.005 361.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.087 354.427C168.359 354.427 170.201 353.371 170.201 352.067C170.201 350.764 168.359 349.707 166.087 349.707C163.816 349.707 161.974 350.764 161.974 352.067C161.974 353.371 163.816 354.427 166.087 354.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.47 369.87L402.17 429.211",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.712 254.29L155.77 275.059C151.185 277.689 151.252 284.297 155.77 286.86L207.087 316.53",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.587 234.667L84.1564 292.861C79.5709 295.491 79.6384 302.099 84.1564 304.662L165.75 352.067L42.9548 423.142",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.815 179.237L576.484 114.771",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.919 245.456L299.47 346.133V227.653L473.919 126.976V245.456Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.587 280.925L299.47 346.133V227.653L186.587 162.513V280.925Z",
    fill: "#B7DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.564 62.0381L186.587 162.513L299.47 227.653L473.919 126.976L360.564 62.0381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.689 30.7493C352.067 7.35005 327.724 -3.91125 311.271 5.66423L280.386 23.4665L285.309 45.8543C286.523 44.1684 288.006 42.8198 289.759 41.7409C299.065 36.3462 312.821 42.6849 320.509 55.9018C328.196 69.1186 326.915 84.2236 317.609 89.6182C310.664 93.6642 301.223 91.1018 293.671 84.0887L304.595 134.124L335.479 116.322C335.479 116.322 348.021 105.532 362.52 90.6972C375.804 77.1432 379.31 54.1485 365.689 30.7493Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.805 48.5517C321.183 25.1525 296.84 13.9586 280.386 23.4667C263.933 33.0422 261.37 60.7571 271.822 83.5494C279.982 101.352 304.595 134.192 304.595 134.192C304.595 134.192 317.07 123.402 331.635 108.567C344.92 95.013 348.426 71.951 334.805 48.5517ZM317.609 89.6858C308.303 95.0805 294.547 88.7418 286.86 75.5249C279.172 62.3081 280.454 47.2031 289.759 41.8084C299.065 36.4138 312.821 42.7525 320.509 55.9694C328.196 69.1862 326.848 84.2912 317.609 89.6858Z",
    fill: "#4BE0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.147 61.0265C308.573 54.8901 306.955 48.4165 307.157 42.6173C301.156 39.3805 294.749 38.841 289.692 41.8081C280.386 47.2027 279.105 62.3077 286.792 75.5246C294.48 88.7414 308.236 95.0801 317.542 89.6855C322.532 86.7859 325.229 81.0541 325.431 74.3782C320.441 71.6135 315.654 67.028 312.147 61.0265Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.751 353.751C420.222 349.501 419.797 344.644 416.802 342.904C413.808 341.164 409.377 343.198 406.907 347.449C404.437 351.699 404.862 356.555 407.856 358.296C410.851 360.036 415.281 358.002 417.751 353.751Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.683 360.632L423.142 356.856C425.839 352.203 427.12 347.078 426.716 342.56C426.379 338.514 424.693 335.412 422.063 333.861L425.839 327.32C430.694 330.152 433.661 335.344 434.268 341.885C434.808 347.954 433.122 354.63 429.683 360.632Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.799 373.849C393.943 371.016 390.976 365.824 390.369 359.283C389.83 353.214 391.448 346.538 394.955 340.537L401.496 344.313C398.799 348.966 397.517 354.091 397.922 358.609C398.259 362.655 399.945 365.757 402.575 367.308L398.799 373.849Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.372 368.589L436.831 364.812C447.013 347.347 444.248 326.713 430.762 318.823L434.538 312.282C442.967 317.205 448.497 325.836 450.048 336.693C451.599 347.212 449.238 358.541 443.372 368.589Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.032 388.819C381.603 383.896 376.074 375.265 374.523 364.408C372.972 353.889 375.399 342.56 381.266 332.445L387.807 336.221C377.625 353.686 380.389 374.321 393.876 382.21L390.032 388.819Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6668 355.429C46.1371 351.179 45.7121 346.323 42.7175 344.582C39.7229 342.842 35.2928 344.876 32.8225 349.127C30.3522 353.377 30.7773 358.234 33.7718 359.974C36.7664 361.714 41.1965 359.68 43.6668 355.429Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5647 362.317L49.0238 358.541C51.7211 353.888 53.0023 348.763 52.5977 344.245C52.2605 340.199 50.5747 337.097 47.9448 335.546L51.7211 329.005C56.5762 331.838 59.5433 337.03 60.1502 343.571C60.6896 349.64 59.0713 356.316 55.5647 362.317Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6805 375.534C19.8253 372.702 16.8582 367.51 16.2513 360.969C15.7119 354.9 17.3303 348.224 20.8368 342.222L27.3778 345.998C24.6805 350.651 23.3992 355.776 23.8038 360.294C24.141 364.34 25.8268 367.442 28.4567 368.993L24.6805 375.534Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3211 370.342L62.7801 366.565C72.9625 349.1 70.1977 328.466 56.7111 320.576L60.4874 314.035C68.9165 318.958 74.446 327.589 75.9969 338.446C77.5479 348.898 75.1877 360.227 69.3211 370.342Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9816 390.572C7.55252 385.649 2.02302 376.95 0.472061 366.161C-1.0789 355.641 1.34869 344.313 7.21536 334.198L13.7564 337.974C3.57398 355.439 6.33873 376.074 19.8253 383.963L15.9816 390.572Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.543 41.4426C590.013 37.1923 589.588 32.3358 586.594 30.5954C583.599 28.8549 579.169 30.8896 576.699 35.14C574.228 39.3903 574.653 44.2468 577.648 45.9872C580.642 47.7277 585.073 45.693 587.543 41.4426Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.412 48.3495L592.87 44.5732C595.568 39.9204 596.849 34.7955 596.444 30.2774C596.107 26.2315 594.421 23.1296 591.792 21.5786L595.568 15.0376C600.423 17.8698 603.39 23.0621 603.997 29.6031C604.537 35.6721 602.918 42.3479 599.412 48.3495Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.527 61.5663C563.672 58.7341 560.705 53.5417 560.098 47.0007C559.559 40.9318 561.177 34.2559 564.684 28.2544L571.225 32.0306C568.527 36.6835 567.246 41.8084 567.651 46.3264C567.988 50.3724 569.674 53.4743 572.303 55.0253L568.527 61.5663Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.168 56.3065L606.627 52.5303C616.809 35.0651 614.044 14.4307 600.558 6.541L604.334 0C612.763 4.92261 618.293 13.554 619.844 24.4107C621.395 34.9303 619.035 46.259 613.168 56.3065Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.828 76.5365C551.399 71.6139 545.87 62.9825 544.319 52.1258C542.768 41.6063 545.195 30.2775 551.062 20.1626L557.603 23.9388C547.421 41.404 550.185 62.0385 563.672 69.9281L559.828 76.5365Z",
    fill: "#6FBAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2345 414.241V367.442",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.285 414.241V367.442",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.081 99.9356V53.2046",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 330.91,
    y1: 2.70689,
    x2: 319.296,
    y2: 135.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20DB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1449D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 297.463,
    y1: 88.8365,
    x2: 309.841,
    y2: 42.6428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20DB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1449D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 620.316,
    height: 440,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiUAAAFbCAYAAAAKrf7HAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/LoginImage.63417f93.svg";
export { ForwardRef as ReactComponent };